import { ProgCss } from "./ProgCss.Generated";
import { createAndShowConfirm } from "./app";

export function AllowHidingTestDbWarning() {
    for (const testDBwarningEl of document.querySelectorAll(`.${ProgCss.TestOmgevingsWaarschuwing}`)) {
        testDBwarningEl.addEventListener("click", function (evt) {
            const omgeving = document.documentElement.getAttribute("data-niet-productie-omgeving");
            
            createAndShowConfirm(
                "Opmerking",
                `Wilt u tijdelijk de ${omgeving}-omgeving waarschuwing verbergen?\n` + `Ververs de pagina (F5) om het tijdelijke verbergen van de ${omgeving}-omgeving ongedaan te maken.`,
                () => { document.documentElement.removeAttribute("data-niet-productie-omgeving"); },
                () => { evt.preventDefault(); }
            );
        });
    }
};
